import { render, staticRenderFns } from "./DocumentSeries.vue?vue&type=template&id=523b2294&"
import script from "./DocumentSeries.vue?vue&type=script&lang=js&"
export * from "./DocumentSeries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports